/**
 * Created by intellicar-rinas on 22/11/17.
 */
import './CustomOverlay.css';

export default function(lat, lng, map, args) {
    let vm = this;
    let innerHtml;

    vm.markerHeight = 12;
    vm.markerWidth = 12;


    vm.CustomMarker = function (lat, lng, map, args) {
        let self = this;
        self.latlng = new window.google.maps.LatLng(lat, lng);
        self.args = args;
        self.map = map;
        self.setMap(map);

        self.dropAnimation = false;

        self.hide = function () {
            if (self.div) {
                self.visiblity = false;
                self.div.style.display = 'none';
            }
        };
        self.show = function () {
            if (self.div) {
                self.visiblity = true;
                self.div.style.display = 'block';
            }
        };

        self.hideVehicleNumber = function () {
            if(self.vehicleNumberWindow){
                self.vehicleNumberWindow.style.display = 'none';
            }
        };
        self.showVehicleNumber = function () {
            if(self.vehicleNumberWindow){
                self.vehicleNumberWindow.style.display = 'block';
            }
        }
    };


    vm.CustomMarker.prototype = new window.google.maps.OverlayView();


    vm.CustomMarker.prototype.setPosition = function (obj) {
        let self = this;
        self.latlng = new window.google.maps.LatLng(obj.latitude, obj.longitude);
        if (self.getProjection()) {
            self.point = self.getProjection().fromLatLngToDivPixel(self.latlng);
            if (self.point && self.div) {
                self.div.style.left = (self.point.x - (vm.markerWidth / 2)) + 'px';
                self.div.style.top = (self.point.y - (vm.markerHeight / 2)) + 'px';
            }
        }
    };


    vm.CustomMarker.prototype.unhighlight = function (str) {
        let self = this;
        if(!self.notifier)
            return;

        if (str != null) {
            str = "-anim-color-" + str;
            let clName = self.notifier.className;
            clName = clName.split(str).join(' ');
            if (clName.indexOf('-anim-color-') === -1) {
                self.hide();
                self.notifier.className = 'overlayNotifier';
                self.dropAnimation = false;
            } else {
                // console.log(clName);
                self.notifier.className = clName;
            }
        } else {
            self.hide();
            self.notifier.className = 'overlayNotifier';
            self.dropAnimation = false;
        }
    };


    vm.CustomMarker.prototype.highlight = function (str) {
        let self = this;
        if (str != null) {
            str = " -anim-color-" + str;
        } else {
            str = "";
        }

        if(!self.notifier)
            return;

        let clName = self.notifier.className;
        if (clName.indexOf('-anim-color-') === -1) {
            self.show();
            self.notifier.className = 'overlayNotifier animate ' + str;
            self.dropAnimation = true;
        } else {
            self.notifier.className = clName + str;
        }

    };

    //
    // vm.CustomMarker.prototype.unhighlight = function () {
    //     let self = this;
    //     self.hide();
    //     self.notifier.className = 'overlayNotifier';
    //     self.dropAnimation = false;
    // };
    //
    //
    // vm.CustomMarker.prototype.highlight = function (str) {
    //     let self = this;
    //     if (str != null) {
    //         str = "-anim-color-" + str;
    //     } else {
    //         str = "";
    //     }
    //     self.show();
    //     self.notifier.className = 'overlayNotifier animate ' + str;
    //     self.dropAnimation = true;
    // };


    vm.CustomMarker.prototype.highlightMe = function (str) {
        let self = this;
        if (str != null) {
            str = "-anim-color-" + str;
        } else {
            str = "";
        }
        if (self.notifier) {
            if (!self.dropAnimation) {
                self.show();
                self.notifier.className = 'overlayNotifier animate ' + str;
                self.dropAnimation = true;
            } else {
                self.hide();
                self.notifier.className = 'overlayNotifier';
                self.dropAnimation = false;
            }
        }
    };


    vm.CustomMarker.prototype.draw = function () {

        let self = this;
        if (!self.div) {

            // initializing DOM Elemets
            self.div = document.createElement('div');

            self.vehicleNumberWindow = document.createElement('div');
            self.notifier = document.createElement('span');
            // Setting propeties
            self.div.className = 'customMarker';
            self.div.style.position = 'absolute';
            self.div.style.display = 'none';
            self.div.style.cursor = 'pointer';

            self.vehicleNumberWindow.className = 'vehicleNumberWindow';
            innerHtml = '<input style="width: ' + self.args.vehicle.vehicleno.length * 8 + 'px" type="text" value="' + self.args.vehicle.vehicleno + '" readonly/> <div class="vnw-close">x</div>';
            self.vehicleNumberWindow.innerHTML = innerHtml;
            self.vehicleNumberWindow.style.display = 'none';


            self.notifier.className = 'overlayNotifier';

            // Appending Elements
            self.div.appendChild(self.vehicleNumberWindow);
            self.div.appendChild(self.notifier);

            //
            // if (typeof(self.args.marker_id) !== 'undefined') {
            //     self.div.dataset.marker_id = self.args.marker_id;
            // }

            window.google.maps.event.addDomListener(self.div.querySelector('.vnw-close'), "click", function (event) {
                self.hideVehicleNumber();
            });

            window.google.maps.event.addDomListener(self.div.querySelector('input'), "click", function (e) {
                this.select();
                console.log('clicked!');
            });
            let panes = this.getPanes();
            panes.overlayImage.appendChild(self.div);
        }


        this.point = this.getProjection().fromLatLngToDivPixel(this.latlng);
        if (this.point) {
            self.div.style.left = (this.point.x - (vm.markerWidth / 2)) + 'px';
            self.div.style.top = (this.point.y - (vm.markerHeight / 2)) + 'px';
        }
    };


    vm.CustomMarker.prototype.remove = function () {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };


    vm.CustomMarker.prototype.getPosition = function () {
        return this.latlng;
    };

    return new this.CustomMarker(lat, lng, map, args)
}